// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderOptions_sub-label__KjiQt {
  font-size: 12px;
}

.OrderOptions_offer-head__3mLK0 {
  margin-bottom: 8px;
}

.OrderOptions_eta__Hbw8N {
  font-size: 12px;
}

.OrderOptions_eta-green-color__L5117 {
  color: green;
  float: right;
}

.OrderOptions_eta-red-color__4vZb\\+ {
  color: red;
  float: right;
}

.OrderOptions_card-body__jxqdv {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/views/Offers/OrderOptions/OrderOptions.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,YAAA;EACA,YAAA;AACJ;;AAEA;EACI,UAAA;EACA,YAAA;AACJ;;AAEA;EACI,eAAA;AACJ","sourcesContent":[".sub-label {\n    font-size: 12px;\n}\n\n.offer-head {\n    margin-bottom: 8px;\n}\n\n.eta {\n    font-size: 12px;\n}\n\n.eta-green-color {\n    color: green;\n    float: right;\n}\n\n.eta-red-color {\n    color: red;\n    float: right;\n}\n\n.card-body {\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sub-label": `OrderOptions_sub-label__KjiQt`,
	"offer-head": `OrderOptions_offer-head__3mLK0`,
	"eta": `OrderOptions_eta__Hbw8N`,
	"eta-green-color": `OrderOptions_eta-green-color__L5117`,
	"eta-red-color": `OrderOptions_eta-red-color__4vZb+`,
	"card-body": `OrderOptions_card-body__jxqdv`
};
export default ___CSS_LOADER_EXPORT___;
